export default __webpack_public_path__ + "static/media/D974CDD6-A53A-4E33-ADCC-447BA504E870_1_105_c.d6ae4545.jpeg";